module.exports = __webpack_public_path__ + "5dc13812eb5388292a2d4a1801813dfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1080.jpg
// module id = 357
// module chunks = 0